<div class="deviation-text">
    <div class="text">{{deviation?.deviation?.toString()}}
        <span>({{deviation?.text | translate}})</span>
    </div>
    <div class="icon" [ngStyle]="{'background-color': deviation?.color}"></div>
</div>
